import { PagedSingleSelectField, isSuccess, laravelServiceSelectFetchConfig } from "@dgs/core";
import { useQueryClient } from "@tanstack/react-query";
import { FC, useCallback } from "react";
import { locationService as sharedLocationService } from "../../../admin/src/shared/api/locationService";
import { locationService } from "../../api/locationService";
import { LocationOptionResource } from "../../types/location";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	clearable?: boolean;
	required?: boolean;
}

export const CreatableLocationField: FC<Props> = ({ name, label, disabled, clearable = true, required = false }) => {
	const queryClient = useQueryClient();

	const createNewLocation = useCallback(
		async (search: string, selectNewOption: (selected: LocationOptionResource) => any) => {
			const res = await locationService.store({ name: search });

			if (isSuccess(res)) {
				selectNewOption({ id: res.data.data.id, name: search });
				void queryClient.invalidateQueries({ queryKey: sharedLocationService.indexKey });
			}
		},
		[queryClient],
	);

	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			disabled={disabled}
			fetchConfig={laravelServiceSelectFetchConfig(locationService)}
			clearable={clearable}
			required={required}
			onCreate={createNewLocation}
		/>
	);
};
